import { inject, Injectable } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { SupportChatWindowDesktopDrawerComponent } from '@shared/support-chat-window/support-chat-window-desktop-drawer/support-chat-window-desktop-drawer.component';
import { BehaviorSubject } from 'rxjs';
import { ROLES_KEYS } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class SupportChatWindowDesktopDrawerService {
  private readonly drawerService = inject(NzDrawerService);

  private drawerRef: NzDrawerRef;
  private openedChatId: string;

  public chatListPanelOpened$ = new BehaviorSubject<boolean>(false);

  public open(chatId: string, userRole: ROLES_KEYS): void {
    if (this.drawerRef) {
      if (this.openedChatId === chatId) {
        return;
      }

      this.drawerRef.close();

      this.drawerRef.afterClose.subscribe(() => {
        this.createDrawer(chatId, userRole);
      });

      return;
    }

    this.createDrawer(chatId, userRole);
  }

  private createDrawer(chatId: string, userRole: ROLES_KEYS): void {
    this.openedChatId = chatId;

    this.drawerRef = this.drawerService.create({
      nzContent: SupportChatWindowDesktopDrawerComponent,
      nzPlacement: 'right',
      nzClosable: false,
      nzMask: false,
      nzWidth: '500px',
      nzWrapClassName: 'custom-support-chat-drawer',
      nzBodyStyle: {
        padding: '0',
        overflow: 'hidden',
      },
      nzContentParams: {
        supportChatId: chatId,
        supportChatUserRole: userRole,
        chatListPanelOpened$: this.chatListPanelOpened$,
      },
    });

    this.drawerRef.afterClose.subscribe(() => {
      this.drawerRef = null;
      this.openedChatId = null;
    });
  }

  public updateChatsListPanelState(isOpen: boolean): void {
    this.chatListPanelOpened$.next(isOpen);
  }

  public close(): void {
    if (this.drawerRef) {
      this.drawerRef.close();
    }
  }
}
